import './ConfidenceMeterGroup.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import ConfidenceRequestButton from './ConfidenceRequestButton';
import zeroMeter from 'assets/MGP-Gauge.png';
import {
  hasRequestedMonteCarloConfidenceScores,
  hasReceivedMonteCarloConfidenceScores
} from 'state/requests/RequestStatusSelectors';
import { getMonteCarloConfidenceScore } from 'state/account/ConfidenceScoresSelectors';
import { getCustomerHouseholdId } from 'state/customer/CustomerSelectors';

const ConfidenceMeterGroup = ({
  householdId,
  monteCarloConfidenceScores,
  requested,
  received
}) => {
  const { image, imageExtension } = monteCarloConfidenceScores;
  const src = image
    ? `data:image/${imageExtension};base64,${image}`
    : zeroMeter;

  return (
    <div className="confidence-meter-group">
      {requested && !received ? (
        <Spinner id="spinner-margin-override" />
      ) : (
        <Fragment>
          <img src={src} alt="Your Confidence Meter." />
          {!received && <ConfidenceRequestButton householdId={householdId} />}
        </Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  householdId: getCustomerHouseholdId(state),
  monteCarloConfidenceScores: getMonteCarloConfidenceScore(state),
  requested: hasRequestedMonteCarloConfidenceScores(state),
  received: hasReceivedMonteCarloConfidenceScores(state)
});

export default connect(mapStateToProps)(ConfidenceMeterGroup);
